export enum SnackbarType {
	INFO,
	ERROR
}
